import {
  levelContainerCssAvg,
  boldDataCss,
  commonLevelCss,
} from "../TableCells.style";

interface TableCellProps {
  cell: {
    value: {
      lexileLevel?: string;
      gradeLevel?: number;
    };
    row: {
      index: number;
    };
  };
  isAvg?: boolean | undefined;
}

const TextLevelTableCell = ({ cell, isAvg = false }: TableCellProps) => {
  const gradeLabel = cell.value?.gradeLevel
    ? `Grade ${String(cell.value.gradeLevel)}`
    : "N/A";
  const lexileLabel = cell.value?.lexileLevel ?? "";

  if (isAvg) {
    return (
      <div css={levelContainerCssAvg}>
        <p css={boldDataCss}>{gradeLabel}</p>
        {lexileLabel ? (
          <p css={commonLevelCss}>&nbsp;-&nbsp;{lexileLabel}</p>
        ) : null}
      </div>
    );
  } else {
    return (
      <div>
        <p css={boldDataCss}>{lexileLabel}</p>
        <p css={commonLevelCss}>{gradeLabel}</p>
      </div>
    );
  }
};

export default TextLevelTableCell;
